<template>
  <div>
    <v-card class="mx-auto mb-5">
      <v-card-text class="pa-5 black--text">
        <v-list three-line class="pb-0">
          <v-list-item class="px-0">
            <v-list-item-avatar color="blue">
              <v-icon dark>mdi-home</v-icon>
            </v-list-item-avatar>
            <v-list-item-content class="py-0 px-1">
              <v-row>
                <v-col cols="12" lg="4">
                  <div class="body-2 grey--text">Info Sekolah</div>
                  <div class="blue--text body-1">
                    {{ $getDeepObj(pelaksana, 'sekolah.nama') || '-' }}
                  </div>
                  <div class="body-2">
                    <b>NPSN : </b>
                    {{ $getDeepObj(pelaksana, 'sekolah.npsn') || '-' }}
                  </div>
                  <div class="body-2">
                    <b>Kota : </b>
                    {{
                      $getDeepObj(pelaksana, 'sekolah.m_kota.keterangan') ||
                        $getDeepObj(pelaksana, 'sekolah.m_kota.data.keterangan') ||
                        '-'
                    }}
                    -
                    {{
                      $getDeepObj(pelaksana, 'sekolah.m_propinsi.keterangan') ||
                        $getDeepObj(pelaksana, 'sekolah.m_propinsi.data.keterangan') ||
                        '-'
                    }}
                  </div>
                  <div class="body-2">
                    <b>Jenjang : </b>
                    {{
                      $getDeepObj(pelaksana, 'sekolah.m_jenjang.singkat') ||
                        $getDeepObj(pelaksana, 'sekolah.m_jenjang.data.keterangan') ||
                        '-'
                    }}
                  </div>
                  <div class="body-2">
                    <b>Status : </b>
                    {{ +$getDeepObj(pelaksana, 'sekolah.is_negeri') === 1 ? 'Negeri' : 'Swasta' }}
                  </div>
                  <div class="body-2">
                    <b>Kepala Sekolah : </b>
                    {{ $getDeepObj(pelaksana, 'ptk.nama') || $getDeepObj(pelaksana, 'ptk.data.nama') || '' }}
                  </div>
                </v-col>
                <v-col cols="12" lg="4">
                  <div class="body-2 grey--text">Fasilitator</div>
                  <div class="blue--text body-1">
                    {{ $getDeepObj(pspKpPaPendampingan, 'psp_profil_pa.data.ptk.data.nama') || '' }}
                  </div>
                  <div class="body-2">
                    <b>SIMPKB ID : </b>
                    {{ $getDeepObj(pspKpPaPendampingan, 'psp_profil_pa.data.ptk_id') || '' }}
                  </div>
                </v-col>
                <v-col cols="12" lg="4">
                  <div class="body-2 grey--text">Periode Laporan</div>
                  <div>
                    <v-chip color="green" class="white--text">
                      {{
                        $getDeepObj(meta, `pendampingan_ke.${pendampinganKe}`) ||
                          $getDeepObj(
                            pelaksana,
                            `pendampingan_ke.${$getDeepObj(
                              pspKpPaPendampingan,
                              'psp_kp_pa.data.tahun_ke'
                            )}.${pendampinganKe}`
                          ) ||
                          ''
                      }}
                    </v-chip>
                  </div>
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>
    <v-card class="mx-auto">
      <v-card-text class="pa-5 black--text">
        <v-row v-for="(kategori, id) in schema" :key="id">
          <v-col v-if="!kategori.hidden" cols="12">
            <div class="font-weight-medium mb-1" style="font-size: 20px"> {{ kategori.title }} </div>
            <base-form-generator :schema="kategori.laporan" v-model="form" class="pt-4" />
          </v-col>
        </v-row>
        <v-row v-if="isPreviewRekaman || (!isLoginKs && !instansi.instansi_id)">
          <v-col cols="12">
            <div class="font-weight-medium mb-2" style="font-size: 20px"> Tautan Rekaman </div>
            <v-row v-for="(meeting, m) in form.data_meeting_pmo" :key="m" no-gutters>
              <v-col cols="12" md="9">
                <base-form-generator
                  :key="m"
                  :schema="schemaMeetings"
                  v-model="form.data_meeting_pmo[m]"
                  @input="getDurasi(form.data_meeting_pmo[m], m)"
                />
                <div class="blue--text mt-4 ml-1 mb-2">
                  {{ (durasis && durasis[Number(m)]) || '' }}
                </div>
              </v-col>
              <v-col cols="12" md="3" sm="12" v-if="(!isPreview && m > 0) || (form.data_meeting_pmo || []).length > 1">
                <div class="white--text">Aksi</div>
                <div class="ml-2" style="margin-top: 2px">
                  <v-btn class="text-capitalize" color="error" depressed @click="onDelRekaman(m)">
                    <v-icon left>mdi-delete</v-icon> Hapus
                  </v-btn>
                </div>
              </v-col>
              <v-col cols="12" md="3" sm="12" v-else-if="isPreview">
                <div class="white--text">Aksi</div>
                <div class="ml-2" style="margin-top: 2px">
                  <v-btn
                    class="text-capitalize"
                    color="success"
                    depressed
                    :href="$getDeepObj(form.data_meeting_pmo[m], 'url_meeting')"
                    target="_blank"
                  >
                    <v-icon left>mdi-eye</v-icon>
                    Lihat
                  </v-btn>
                </div>
              </v-col>
            </v-row>
            <v-row v-if="!(form.data_meeting_pmo || []).length && isPreview">
              <v-col cols="12" class="grey--text">Belum ada rekaman yang diunggah</v-col>
            </v-row>
            <v-btn
              v-if="!isPreview"
              @click="onAddRekaman"
              color="primary"
              depressed
              class="text-capitalize"
              :disabled="form.data_meeting_pmo.length >= 5"
            >
              <v-icon left dark>
                mdi-plus
              </v-icon>
              Tambah Tautan
            </v-btn>
          </v-col>
        </v-row>
        <template v-if="isPreviewBerkas || isLoginKs">
          <div class="mt-5" v-for="(schBerkas, id) in schemaBerkas" :key="id">
            <v-row v-if="!schBerkas.hidden">
              <v-col cols="12">
                <div class="font-weight-medium mb-2" style="font-size: 20px"> Lampiran {{ schBerkas.title }} </div>
                <div v-if="schBerkas.desc" class="body-2 grey--text mb-2">{{ schBerkas.desc }}</div>
                <v-row class="mt-1 mb-2">
                  <div v-if="schBerkas.label"></div>
                  <template>
                    <v-col v-if="(schBerkas.berkases || []).length" cols="12" sm="12" md="12" class="pt-1">
                      <v-row v-for="(file, f) in schBerkas.berkases" :key="f" dense>
                        <v-col cols="12" md="9" sm="12">
                          <div class="grey lighten-3 pa-2 black--text">{{ file.judul }}</div>
                        </v-col>
                        <v-col cols="12" md="3" sm="12" class="my-auto">
                          <div>
                            <v-btn
                              class="text-capitalize"
                              color="success"
                              depressed
                              :href="file.url_berkas"
                              target="_blank"
                            >
                              <v-icon left>mdi-eye</v-icon>
                              Lihat
                            </v-btn>
                            <v-btn
                              v-if="!isPreview"
                              class="mx-1 text-capitalize"
                              color="red"
                              dark
                              depressed
                              @click="onDelBerkas(file)"
                            >
                              <v-icon left>mdi-delete</v-icon>
                              Hapus
                            </v-btn>
                          </div>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col
                      v-if="!(schBerkas.berkases || []).length && isPreview"
                      cols="12"
                      sm="12"
                      md="12"
                      class="pt-0 grey--text"
                    >
                      Belum ada berkas yang diunggah
                    </v-col>
                  </template>
                  <v-col v-if="!isPreview" cols="12" sm="12" md="12" class="py-0 mb-4">
                    <v-btn
                      class="text-capitalize"
                      color="primary"
                      depressed
                      :disabled="schBerkas.max && (schBerkas.berkases || []).length >= schBerkas.max"
                      @click="onAddBerkas(schBerkas)"
                    >
                      <v-icon left>mdi-plus</v-icon> Tambah Berkas
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </div>
        </template>
      </v-card-text>
      <form-berkas ref="berkas" :label="formUpload.label" :title="formUpload.title" @upload="onAddBerkasSave" />
    </v-card>
  </div>
</template>
<script>
import BaseFormGenerator from '@components/base/BaseFormGenerator';
import FormBerkas from './FormBerkas.vue';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'FormPelaksanaanPmo',
  components: { BaseFormGenerator, FormBerkas },
  props: {
    pelaksana: {
      type: Object,
      default: () => {},
    },
    masters: {
      type: Object,
      default: () => {},
    },
    isPreview: {
      type: Boolean,
      default: false,
    },
    isEntry: {
      type: Boolean,
      default: true,
    },
    isLoginKs: {
      type: Boolean,
      default: true,
    },
    id: {
      type: [Number, String],
      default: '',
    },
    pendampinganKe: {
      type: [Number, String],
      default: '',
    },
    meta: {
      type: Object,
      default: () => {},
    },
    detail: {
      type: Object,
      default: () => {},
    },
    pspKpPa: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: { data_meeting_pmo: [{ nama: '', url_meeting: '' }] },
      formUpload: {},
      durasis: [],
    };
  },
  computed: {
    ...mapState('preferensi', {
      instansi: (state) => state?.data?.instansi ?? {},
    }),

    pspKpPaPendampingan() {
      if (!this.isLoginKs) {
        return this.$getDeepObj(this.meta, 'psp_kp_pa_pendampingan') || {};
      }

      return this.$getDeepObj(this.detail, 'psp_kp_pa_pendampingan.data');
    },

    berkases() {
      return (
        this.$getDeepObj(this.detail, 'psp_kp_pa_sekolah_laporan_berkases.data') ||
        this.$getDeepObj(this.detail, 'psp_kp_pa_sekolah_laporan_berkases') ||
        []
      );
    },

    instrumenLaporan() {
      const instrumens =
        this.$getDeepObj(this.detail, 'psp_kp_pa_sekolah_instrumens.data') ||
        this.$getDeepObj(this.detail, 'psp_kp_pa_sekolah_instrumens') ||
        [];
      return this.$arrToObj(instrumens, 'k_kp_instrumen_psp');
    },

    schema() {
      if (this.isPreview) {
        return this.schemaPreview;
      }

      return {
        dasar: {
          title: 'Informasi Dasar',
          laporan: [
            {
              disabled: this.isPreview || !this.isEntry,
              type: 'VDatePicker',
              name: 'tgl_pelaksanaan_pmo',
              label: 'Tenggal Pelaksanaan',
              labelColor: 'indigo',
              placeholder: 'Pilih tanggal Pelaksanaan',
              usePrependInnerIcon: 'mdi-calendar-month',
              hint: 'wajib diisi',
              outlined: true,
              singleLine: true,
              hideDetails: true,
              dense: true,
              grid: { cols: 12, md: 6, sm: 12 },
            },
            {
              disabled: this.isPreview || !this.isEntry,
              type: 'VTextField',
              name: 'jml_peserta_pmo',
              label: 'Jumlah peserta',
              labelColor: 'indigo',
              hint: '',
              mask: '###',
              required: false,
              outlined: true,
              singleLine: true,
              hideDetails: true,
              dense: true,
              readonly: this.readOnly,
              grid: { cols: 12, md: 6, sm: 12 },
            },
            {
              disabled: this.isPreview || !this.isEntry,
              type: 'VTextarea',
              name: 'instrumen-201',
              label: 'Hasil refleksi pembelajaran dan karakter berbasis peserta didik',
              labelColor: 'indigo',
              placeholder: 'Tuliskan deskripsi',
              hint: 'wajib diisi',
              outlined: true,
              dense: true,
              singleLine: true,
              rows: 2,
              autoGrow: true,
              counter: false,
              hideDetails: true,
              counterValue: (v) => this.$wordCount(v),
              grid: { cols: 12 },
            },
            {
              disabled: this.isPreview || !this.isEntry,
              type: 'VTextarea',
              name: 'instrumen-202',
              label: 'Akar masalah dari hasil refleksi pembelajaran dan karakter yang telah dilakukan',
              labelColor: 'indigo',
              placeholder: 'Tuliskan deskripsi',
              hint: 'wajib diisi',
              outlined: true,
              dense: true,
              singleLine: true,
              rows: 2,
              autoGrow: true,
              counter: false,
              counterValue: (v) => this.$wordCount(v),
              grid: { cols: 12 },
            },
          ],
        },
      };
    },

    schemaPreview() {
      return {
        dasar: {
          title: 'Informasi Dasar',
          laporan: [
            {
              type: 'textView',
              label: 'Tanggal Pelaksanaan',
              labelColor: 'indigo',
              bgColor: 'grey lighten-3 pa-2 mb-4',
              value: this.$localDate(this.$getDeepObj(this.detail, 'tgl_pelaksanaan_pmo')) || '',
              grid: { cols: 12, md: 6 },
            },
            {
              type: 'textView',
              label: 'Jumlah Peserta',
              labelColor: 'indigo',
              bgColor: 'grey lighten-3 pa-2 mb-4',
              value: this.$getDeepObj(this.detail, 'jml_peserta_pmo') || '',
              grid: { cols: 12, md: 6 },
            },
            {
              type: 'textView',
              label: 'Hasil refleksi pembelajaran dan karakter berbasis peserta didik',
              labelColor: 'indigo',
              bgColor: 'grey lighten-3 pa-2 mb-4',
              value: this.$getDeepObj(this.instrumenLaporan, '201.deskripsi') || '',
              grid: { cols: 12 },
            },
            {
              type: 'textView',
              label: 'Akar masalah dari hasil refleksi pembelajaran dan karakter yang telah dilakukan',
              labelColor: 'indigo',
              bgColor: 'grey lighten-3 pa-2 mb-4',
              value: this.$getDeepObj(this.instrumenLaporan, '202.deskripsi') || '',
              class: 'mb-4',
              grid: { cols: 12 },
            },
          ],
        },
      };
    },

    schemaMeetings() {
      return [
        {
          disabled: this.isPreview || !this.isEntry,
          type: 'VTextField',
          name: 'nama',
          label: 'Judul Link Pertemuan Daring',
          labelColor: 'indigo',
          hint: '',
          grid: { cols: 12, md: 6, sm: 12 },
          outlined: true,
          singleLine: true,
          dense: true,
          hideDetails: true,
          readonly: this.isPreview,
        },
        {
          disabled: this.isPreview || !this.isEntry,
          type: 'VTextField',
          name: 'url_meeting',
          label: 'Link Video Reference',
          labelColor: 'indigo',
          hint: '',
          grid: { cols: 12, md: 6, sm: 12 },
          outlined: true,
          singleLine: true,
          dense: true,
          hideDetails: true,
          readonly: this.isPreview,
          prependInnerIcon: 'mdi-video',
        },
      ];
    },

    schemaBerkas() {
      return [
        {
          hidden: false,
          label: 'foto-pmo',
          title: 'Dokumentasi pelaksanaan PMO Sekolah ',
          desc: 'Unggah 2 berkas dokumentasi pelaksanaan PMO Sekolah',
          max: 2,
          berkases: this.berkases,
        },
      ];
    },

    isPreviewRekaman() {
      const dataMeeting = this.$getDeepObj(this.detail, 'data_meeting_pmo') || [];
      return this.isPreview && dataMeeting.length > 0;
    },

    isPreviewBerkas() {
      return this.isPreview && this.berkases.length > 0;
    },
  },
  methods: {
    ...mapActions('preferensi', ['cekRekaman']),
    ...mapActions('laporan', ['upload', 'actions']),

    reset() {
      this.$set(this, 'form', { data_meeting_pmo: [{ nama: '', url_meeting: '' }] });
      this.$set(this, 'durasis', []);

      if (this.$isObject(this.detail)) {
        const instrumens = this.$getDeepObj(this.detail, 'psp_kp_pa_sekolah_instrumens.data') || [];
        const instrumensObj = this.$arrToObj(instrumens, 'k_kp_instrumen_psp');

        for (const sch of Object.values(this.schema)) {
          for (const input of sch.laporan) {
            if (input.type !== 'textView') {
              if (/instrumen/.test(input.name)) {
                const ins = input.name.split('-');
                this.$set(this.form, input.name, this.$getDeepObj(instrumensObj[ins[1] || ''], `deskripsi`) || '');
              } else {
                this.$set(this.form, input.name, this.detail[input.name] || '');
              }
            }
          }
        }

        // meeting
        const meetings = this.$getDeepObj(this.detail, 'data_meeting_pmo') || [];
        for (const id in meetings) {
          const meet = meetings[id] || {};
          if (+id === 0) {
            this.form.data_meeting_pmo[0]['nama'] = meet.nama || '';
            this.form.data_meeting_pmo[0]['url_meeting'] = meet.url_meeting || '';
          } else {
            this.form.data_meeting_pmo.push({
              nama: meet.nama || '',
              url_meeting: meet.url_meeting || '',
            });
          }

          this.durasis.push(this.$durasiWaktu(meet.durasi));
        }
      }

      // delete link meeting kosong saat preview
      if (this.isPreview) {
        const linkMeeting = (this.form.data_meeting_pmo || []).filter((meet) => !!meet.url_meeting);
        if (!linkMeeting.length) {
          this.$set(this.form, 'data_meeting_pmo', []);
        }
      }
    },

    getDurasi(item, index) {
      if (!item.url_meeting) return;
      clearTimeout(this.debouce);
      this.debouce = setTimeout(() => {
        this.cekRekaman({ rekaman_url: item.url_meeting }).then((resp) => {
          const duration = (resp && resp.videoMediaMetadata && resp.videoMediaMetadata.durationMillis) || null;
          if (duration) {
            this.$set(this.durasis, index, this.$durasiWaktu(duration));
          }
        });
      }, 1000);
    },

    onAddRekaman() {
      this.form.data_meeting_pmo.push({ url_meeting: '' });
    },

    onDelRekaman(index) {
      this.form.data_meeting_pmo.splice(index, 1);
      this.$delete(this.durasis, index);
    },

    onAddBerkas(berkas) {
      this.$set(this.formUpload, 'label', berkas.label);
      this.$set(this.formUpload, 'title', berkas.title);

      this.$refs.berkas.open();
      this.$refs.berkas.stopLoading();
    },

    onAddBerkasSave(berkas) {
      const params = new FormData();
      let attr = {
        endpoint: `pendampingan-ks/${this.pspKpPa.psp_kp_pa_id}/pelaksana/${this.pelaksana.psp_pelaksana_id}/berkas-insert`,
      };
      if (!this.isLoginKs) {
        const pspKpPaPendampinganId = this.meta.psp_kp_pa_pendampingan_id;
        const pspKpPaSekolahId = this.meta.psp_kp_pa_sekolah_id;
        attr = { endpoint: `pendampingan-pa/${pspKpPaPendampinganId}/berkas-pmo/${pspKpPaSekolahId}/insert` };
      }

      params.append('jenis', this.formUpload.label);
      params.append('judul', berkas.judul);
      params.append('file', berkas.file);
      params.append('pendampingan_ke', this.pendampinganKe);

      this.$refs.berkas.startLoading();
      this.upload({ attr, params })
        .then(() => {
          this.$emit('refresh', this.pendampinganKe);
          this.$success('Berkas berhasil diunggah');
          this.$refs.berkas.close();
          this.$refs.berkas.stopLoading();
        })
        .catch(() => {
          this.$refs.berkas.stopLoading();
        });
    },

    onDelBerkas(berkas) {
      let id = this.$getDeepObj(berkas, `psp_kp_pa_sekolah_laporan_berkas_id`);
      let endpoint = `pendampingan-ks/${this.pspKpPa.psp_kp_pa_id}/pelaksana/${this.pelaksana.psp_pelaksana_id}/berkas-delete`;

      if (!this.isLoginKs) {
        const pspKpPaPendampinganId = this.meta.psp_kp_pa_pendampingan_id;
        const pspKpPaSekolahId = this.meta.psp_kp_pa_sekolah_id;

        endpoint = `pendampingan-pa/${pspKpPaPendampinganId}/berkas-pmo/${pspKpPaSekolahId}/${id}`;
        id = 'delete';
      }

      this.$confirm(`Apakah Anda yakin ingin menghapus berkas <b>${berkas.judul}</b> ?`, 'Peringatan', {
        tipe: 'error',
      }).then(() => {
        this.actions({ endpoint, id }).then(() => {
          this.$success('Berkas berhasil dihapus');
          this.$emit('refresh', this.pendampinganKe);
        });
      });
    },

    getValue() {
      const values = Object.assign({}, this.form, { instrumen: [] });

      const dataMeeting = (values.data_meeting_pmo || []).filter((meet) => !!meet.url_meeting);
      if (this.isLoginKs || !dataMeeting.length) {
        values['data_meeting_pmo'] = [];
      }

      // instrumen
      for (const ins of Object.keys(this.form)) {
        if (/instrumen/.test(ins)) {
          const instrumen = ins.split('-');
          const kInstrumen = instrumen[1];

          values.instrumen.push({
            k_kp_instrumen_psp: kInstrumen,
            jawaban: 1,
            deskripsi: this.form[ins] || '',
          });

          delete values[ins];
        }
      }

      return values;
    },
  },
};
</script>
<style scoped>
.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
.sc-notif {
  background-color: #c8e6c9;
}
.v-expansion-panel-content >>> .v-expansion-panel-content__wrap {
  padding: 0 !important;
}
</style>
